/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dnamw_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ssRNA ACGU = 1223.81 g/mol.`)
};

const es_dnamw_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ARNss ACGU = 1223.81 g/mol.`)
};

const de_dnamw_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ssRNA ACGU = 1223,81 g/mol.`)
};

const nl_dnamw_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ssRNA ACGU = 1223,81 g/mol.`)
};

const fr_dnamw_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ARNsb ACGU = 1223,81 g/mol.`)
};

const it_dnamw_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ssRNA ACGU = 1223,81 g/mol.`)
};

const pt_br2_dnamw_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ssRNA ACGU = 1223,81 g/mol.`)
};

const pt_dnamw_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ssARN ACGU = 1223,81 g/mol.`)
};

const ja_dnamw_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ssRNA ACGU = 1223.81 g/mol。`)
};

const zh_dnamw_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ssRNA ACGU = 1223.81 g/mol。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dnamw_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dnamw_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dnamw_ex2", locale)
	if (locale === "en") return en_dnamw_ex2(inputs)
	if (locale === "es") return es_dnamw_ex2(inputs)
	if (locale === "de") return de_dnamw_ex2(inputs)
	if (locale === "nl") return nl_dnamw_ex2(inputs)
	if (locale === "fr") return fr_dnamw_ex2(inputs)
	if (locale === "it") return it_dnamw_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_dnamw_ex2(inputs)
	if (locale === "pt") return pt_dnamw_ex2(inputs)
	if (locale === "ja") return ja_dnamw_ex2(inputs)
	return zh_dnamw_ex2(inputs)
};